/*  数据元提供者
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：吴凤楠                         创建日期：2014/05/04
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 
 
 
 *******************************************************************************/
import { DataType } from './DataType';
import { PrmFactory } from './PrmFactory';

const DataElement = window.DataElement = {
    /**
     * 对外接口，根据sguid取得数据元信息
     * @param {String} key
     * @returns 数据元对象
     */
    getDE: function (key) {
        var de;
        // var ap = sgiCommon.getAP(key);
        var ap = tool.Global.currentAP;
        if (!ap) {
            de = {};
            return de;
        }
        var deMap = DataElement[ap + "DeMap"];
        if (!deMap) {
            deMap = this.loadDE(ap);
        }
        de = deMap[key];
        if (!de) {
            de = {};
            return de;
        }
        return de;
    },
    /**
     * 加载数据元到缓存对象
     * @param {String} ap
     * @return {map} deMap
     */
    loadDE: function (ap) {
        var deMap = {};
        DataElement[ap + "DeMap"] = deMap;

        // var deMap = DataElement[ap + "DeMap"];
        //数据元缓存对象
        var guid = ap + '_MD_DE_0001';
        var ddTree = PrmFactory.getPrm(guid);
        ddTree.cldSet.forEach(record => {
            var dt = DataType.getDT(record.t);
            record.jst = dt.c;
            record.dbt = dt.dbt;//数据类型
            record.jt = dt.t; //程序类型
            deMap[record.sc] = record;
        });
        return deMap;
    }
}
export { DataElement };
export default DataElement;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/DataElement.js